import env from '@/assets/env';
// eslint-disable-next-line import/no-cycle
import store from '../store';

const path = ( a, queryOptions = null ) => {
	const query = ( () => {
		if ( !queryOptions ) {
			return '';
		}

		const queryKeys   = Object.keys( queryOptions );
		const queryString = queryKeys
			.map( ( key ) => {

				const value = queryOptions[key];
				if ( typeof value !== 'object' ) {
					return `${key}=${encodeURIComponent( queryOptions[key] )}`;
				}

				return encodeArray( key, value );
			} )
			.filter( q => q.length )
			.join( '&' );

		return `?${queryString}`;
	} )();

	return `${env.API_PROTOCOL}://${env.API_URL}/${a}${query}`;
};

const encodeArray = ( key, arr ) => { // eslint-disable-line

	return arr.reduce( ( a, item, i ) => {

		// For 1 dimensional arrays
		if ( !Array.isArray( item ) ) {
			a.push( `${key}[${i}]=${encodeURIComponent( item )}` );
			return a;
		}

		// For 2 dimensional arrays
		item.forEach( ( x, j ) => {
			if ( typeof x === 'object' ) {
				const objKeys = Object.keys( x );
				objKeys.forEach( ( objKey ) => {
					a.push( `${key}[${i}][${j}][${objKey}]=${encodeURIComponent( x[objKey] )}` );
				} );

				return;
			}
			a.push( `${key}[${i}][${j}]=${encodeURIComponent( x )}` );
		} );

		return a;

	}, [] )
		.join( '&' );
};


// eslint-disable-next-line no-async-promise-executor
const fetchPromise = ( route, options ) => new Promise( async ( resolve, reject ) => {
	//console.log('fetch promise');
	//console.log(route);
	//console.log(options);
	//console.log('');
	try {
		await fetch( route, options )
			.then( async ( res ) => {
				const status = parseInt( res.status, 10 );
        if(status === 401) { //Handle Refresh Token
          //console.log(route);
          if(route.indexOf('refresh-token') === -1) {
            //const refreshTokenCall = await RefreshToken();
            //if(refreshTokenCall) {
            //  console.log('store data');
            //  await store.dispatch('RefreshToken', refreshTokenCall);
            //  //  console.log(options);
            //  resolve(fetchPromise( route, options ));
            //  //console.log('AuthToken: ', store.state.accessToken);
            //  //reject(new Error('why?', store.state.accessToken));
            //
            //}
          }
          //console.log('router: ', this.$router);
          console.log('on login error');
          const data = await res.json()
                                .then((err) => {
                                  reject(err);
                                });

        }
				if ( ( Math.floor( status / 100 ) * 100 ) !== 200 ) {

					await res.json()
						.then( (err) => {
              console.log('json error');
              reject( err );
            });
					return;
				}
				const body = await _body( res );
				resolve( body, res );
			} )
    .catch((e) => {
      console.log('Promise Error');
      console.log(e);
      reject(e);
    });
	}
	catch ( e ) {
		reject( e );
	}
} );



const _body = async ( res ) => {
	console.log(`RES: ${res.status}`);
	if(res.status === 401) {
		this.$router.push('/');
	}
	const text = await res.text();

	const firstChar = text.charAt( 0 );
	const isJson    = ( firstChar === '{' || firstChar === '[' );

	if ( isJson ) {
		return JSON.parse( text );
	}

	return text;
};

const authenticate = method => async ( ...args ) => { // eslint-disable-line
	const authObject = {
		defaultHeaders : await new Headers( {
			'Content-Type' : 'application/json',
			'Auth-Token'   : store.getters.getAccessToken
		} ),
	};
	const allArgs = [authObject].concat( args );
	return method( ...allArgs );
};

export const EmailReport = credentials => fetchPromise( path( 'GDD/emailReport' ), {
	method      : 'POST',
	credentials : 'include',
	headers     : new Headers( {
		'Content-Type' : 'application/json',
	} ),
	body : JSON.stringify( { credentials } )
} );

export const RefreshToken =  () => fetchPromise( path( 'auth/refresh-token' ), {
	method      : 'GET',
	credentials : 'include',
	headers     : new Headers( {
		'Content-Type' : 'application/json',
	} ),
} );

export const SetLogout = () => fetchPromise( path( 'auth/logout' ), {
	method      : 'GET',
	credentials : 'include',
	headers     : new Headers( {
		'Content-Type' : 'applicaiton/json',
	} ),
} );

export const Login = credentials => fetchPromise( path( 'auth/login' ), {
	method      : 'POST',
	credentials : 'include',
	headers     : new Headers( {
		'Content-Type' : 'application/json',
	} ),
	body : JSON.stringify( { credentials } )
} );

export const ForgotPassword = userEmail => fetchPromise( path( 'auth/forgot-password' ), {
	method : 'POST',
	headers : new Headers( {
		'Content-Type' : 'application/json',
	} ),
	body : JSON.stringify( { email : userEmail } )
} );

export const ResetPassword = ( token, password ) => fetchPromise( path( `auth/reset-password/${token}` ), {
	method : 'POST',
	headers : new Headers( {
		'Content-Type' : 'application/json',
	} ),
	body : JSON.stringify( { password } )
} );

export const GetManifests = authenticate( async ( _auth, contractNum, contractYear ) => fetchPromise( path( `contract/manifests/${contractNum}/${contractYear}` ), {
	method  : 'GET',
	headers : _auth.defaultHeaders
} ) );

export const GetSummaryTable = authenticate( ( _auth, rttNums, contractYear ) => fetchPromise( path( 'contract/summary-tables'), {
	method      : 'POST',
	credentials : 'include',
	headers     : _auth.defaultHeaders,
	body: JSON.stringify( {
		rttNums,
		contractYear
	} )
} ) );

export const GetContractList = authenticate( _auth => fetchPromise( path( 'contract/list' ), {
	method      : 'GET',
	credentials : 'include',
	headers     : _auth.defaultHeaders
} ) );

// here are the sprocs being used for Entity Summary

//*
 export const GetTotalPoundsProducedAllYears = authenticate( ( _auth, args)  => fetchPromise( path( 'GDD/getTotalPoundsProducedAllYears', { ContractNum : args }  ), {
 	method  : 'GET',
 	args    : 'include',
 	headers : _auth.defaultHeaders
 } ) );
//*/
/*
export const GetTotalPoundsProducedAllYears = args => fetchPromise( path( 'GDD/getTotalPoundsProducedAllYears', { ContractNum : args } ), {
	method      : 'GET',
	credentials : 'include',
	headers     : new Headers( {
		'Content-Type' : 'application/json',
	} ),
} );
//*/

export const InsectSproc = authenticate( ( _auth, args)  => fetchPromise( path( 'GDD/insectSproc', { ContractNum : args.ContractNum, CropYear : args.CropYear } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const InsectSprocAllYears = authenticate( ( _auth, args ) => fetchPromise( path( 'GDD/getInsectSprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );


export const QualitySproc = authenticate( ( _auth, args ) => fetchPromise( path( 'GDD/qualitySproc', { ContractNum : args.ContractNum, CropYear : args.CropYear } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const QualitySprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/getQualitySprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const YieldByVarietySproc = authenticate( (_auth, args) => fetchPromise( path( 'GDD/yieldByVarietySproc', { ContractNum : args.ContractNum, CropYear : args.CropYear } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const YieldByVarietySprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/yieldByVarietySprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const YieldByFieldSprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/yieldByFieldSprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const QualityByFieldSprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/qualityByFieldSprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const InsectByFieldSprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/insectByFieldSprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const QualityByVarietySprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/qualityByVarietyAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );
export const InsectByVarietySprocAllYears = authenticate( (_auth, args) => fetchPromise( path( 'GDD/insectByVarietySprocAllYears', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const GetYearsAvailable = authenticate( (_auth, args) => fetchPromise( path( 'GDD/get-years-available'), {
	method      : 'GET',
	credentials : 'include',
	headers     : _auth.defaultHeaders
} ) );

export const GetCustomStatus = authenticate( (_auth, args) => fetchPromise( path( 'GDD/get-custom-status', { ContractNum : args } ), {
	method  : 'GET',
	args    : 'include',
	headers : _auth.defaultHeaders
} ) );

export const GetFormsAvailable = authenticate( (_auth, args) => fetchPromise( path( 'GDD/get-form-list'), {
	method      : 'GET',
	credentials : 'include',
	headers     : _auth.defaultHeaders
} ) );


